import { render, staticRenderFns } from "./index-staff.vue?vue&type=template&id=69c1ba0f&"
import script from "./index-staff.vue?vue&type=script&lang=js&"
export * from "./index-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports